import { render, staticRenderFns } from "./selfDialogue.vue?vue&type=template&id=6bb50618&scoped=true"
import script from "./selfDialogue.vue?vue&type=script&lang=js"
export * from "./selfDialogue.vue?vue&type=script&lang=js"
import style0 from "./selfDialogue.vue?vue&type=style&index=0&id=6bb50618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb50618",
  null
  
)

export default component.exports